import api from './api';

export const getAssets = (params) => api.get('/v1/assets', { params });
export const getAsset = (id) => api.get(`/v1/assets/${id}`);
export const createAsset = (data) => api.post('/v1/assets', data);
export const updateAsset = (id, data) => api.put(`/v1/assets/${id}`, data);
export const updateAssetStatus = (id, data) => api.put(`/v1/assets/${id}/status`, data);
export const deleteAsset = (id) => api.delete(`/v1/assets/${id}`);
export const batchDeleteAssets = (ids) => api.post('/v1/assets/batch-delete', ids);
export const getAssetHistory = (id, params) => api.get(`/v1/assets/${id}/history`, { params });
export const getAssetDocuments = (id, params) => api.get(`/v1/assets/${id}/documents`, { params });
export const addAssetDocument = (id, data) => api.post(`/v1/assets/${id}/documents`, data);
export const deleteAssetDocument = (docId) => api.delete(`/v1/assets/documents/${docId}`);
